export default "__VITE_PUBLIC_ASSET__e507d3b7__"